module.exports = "<div class=\"password-form {{passwordCheckbox? 'closed': ''}}\">\r\n  <input type='password' class=\"password-input form-control mb-4\" type=\"{{inputType}}\" (ngModelChange)=\"emitPassword($event)\" [(ngModel)]=\"password\" required\r\n         placeholder=\"Пароль\" name=\"password\"/>\r\n  <button type=button placeholder=\"Пароль\" (click)=\"hideShowPassword()\" class=\"password-btn\"></button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/password/password.component.html
// module id = ../../../../../src/password/password.component.html
// module chunks = 5